import React from "react";
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-173" data-mp="3f1vn7khw8jgk">
      <p className="text-[11px] font-semibold tracking-[0.25em] text-gold sm:text-sm" data-id="element-174" data-mp="3f36mp84b351v">{eyebrow}</p>
      <h2 className="mt-3 font-display text-3xl uppercase leading-[1.05] text-cream sm:text-5xl" data-id="element-175" data-mp="3k29mad1ioj2g">{title}</h2>
      {subtitle && <p className="mt-4 font-serif text-lg italic leading-relaxed text-mute sm:text-xl" data-id="element-176" data-mp="gj6utb0yxdiy">{subtitle}</p>}
    </div>;
}